import { Navigate } from 'react-router-dom'
import { useAuth } from '../modules/auth'
import { toast } from 'react-toastify'

type ProtectedRouteProps = {
  children: JSX.Element
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { currentUser } = useAuth()

  // Step 0: Old architecture case
  if (currentUser?.data?.organisation_settings_complete === -1) {
    return <Navigate to="/settings/organisation-settings" replace />
  }

  // Step 1: Organisation settings check
  if (currentUser?.data?.organisation_settings_complete === 0) {
    return <Navigate to="/settings/organisation-settings" replace />
  }

  // Step 2: Calendar settings check
  if (
    currentUser?.data?.organisation_settings_complete === 1 &&
    currentUser?.data?.calendar_settings_complete === 0
  ) {
    return <Navigate to="/settings/calendar-settings" replace />
  }

  // Step 3: All good → render children
  return children
}

export default ProtectedRoute
